import { Heading } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

type SuggestionsWrapperProps = {
    $isNavBar?: boolean;
    $isNoResults?: boolean;
};

export const SuggestionsWrapper = styled.div<SuggestionsWrapperProps>`
    display: flex;
    flex-wrap: wrap;
    gap: ${getPurpurSpacing('400')};
    padding: ${getPurpurSpacing('300')} ${getPurpurSpacing('200')};

    ${({ $isNavBar, $isNoResults }) =>
        $isNavBar &&
        !$isNoResults &&
        purpurMedia('lg')`
            gap: ${getPurpurSpacing('600')};
            flex-wrap: nowrap;
        `};

    ${purpurMedia('lg')`
        padding: ${getPurpurSpacing('400')};
    `};
`;

export const SectionHeading = styled(Heading)`
    margin-bottom: ${getPurpurSpacing('200')};
    white-space: nowrap;
`;

export const PopularQueriesWrapper = styled.section`
    max-width: 100%;
`;

export const ResultSuggestions = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('400')};
`;

export const SuggestionsCardsWrapper = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;
    grid-auto-rows: 1fr;
    grid-column-gap: ${getPurpurSpacing('200')};
    grid-row-gap: ${getPurpurSpacing('200')};

    ${purpurMedia('md')`
        grid-template-columns: repeat(2, 1fr);
    `};
`;
